/**
 *@author chenli
 *@description 隐藏框控件
 */
import Component from '../../../lib/component';
import template from './hidden-control.html'
let config={
        template:template,
    data:{

    },
    actions:{
    },
}
let HiddenControl = Component.extend(config)
export default HiddenControl


// WEBPACK FOOTER //
// app/components/form/hidden-control/hidden-control.js